<template>
  <div>
    <b-row>
      <b-col sm="6">
        <b-form-group
          label-size='lg'
          label-text-align="left"
          label-class='addpersonlabel'
          label="Show"
          label-for="assessmentIndicatorFilter"
          horizontal
        >
          <b-form-select
            size="lg"
            :options="assessmentIndicatorFilterOptions"
            id="assessmentIndicatorFilter"
            v-model="assessmentIndicatorFilter"
          >
            <option slot="first" :value="null">Choose...</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <!-- Choose a biographical field to group by -->
        <b-form-group
          label-size='lg'
          label-text-align="left"
          label-class='addpersonlabel'
          label='Group By'
          label-for='demographic'
          horizontal
        >
          <b-form-select
            size="lg"
            :options="biographicOptions"
            id='demographic'
            v-model='indicatorsDemographicField'
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6">
        <!-- Choose a specific indicator to look at -->
        <b-form-group
          label-size='lg'
          label-text-align="left"
          label-class='addpersonlabel'
          label='Indicator One'
          label-for='demographic'
          horizontal
        >
          <b-form-select
            size="lg"
            :options="assessmentFields"
            textField='label'
            valueField='name'
            id='indicator'
            v-model='comparisonIndicatorOne'
          >
          </b-form-select>
        </b-form-group>
        <horizontal-bar-chart
          class="chart-wrapper"
          style="height: 400px"
          :apiData="getSingleIndicator(comparisonIndicatorOne)"
          :chartName="getChartNameFromIndicator(comparisonIndicatorOne)"
          :fieldData="assessmentFields"
          valueField="value"
          :labels="getSingleIndicatorLabels(comparisonIndicatorOne)"
        ></horizontal-bar-chart>
      </b-col>
      <b-col sm="6">
        <!-- Choose a specific indicator to look at -->
        <b-form-group
          label-size='lg'
          label-text-align="left"
          label-class='addpersonlabel'
          label='Indicator Two'
          label-for='demographic'
          horizontal
        >
          <b-form-select
            size="lg"
            :options="assessmentFields"
            textField='label'
            valueField='name'
            id='indicator'
            v-model='comparisonIndicatorTwo'
          >
          </b-form-select>
        </b-form-group>
        <horizontal-bar-chart
            class="chart-wrapper"
            style="height: 400px"
            :apiData="getSingleIndicator(comparisonIndicatorTwo)"
            :chartName="getChartNameFromIndicator(comparisonIndicatorTwo)"
            :fieldData="assessmentFields"
            valueField="value"
            :labels="getSingleIndicatorLabels(comparisonIndicatorTwo)"
        ></horizontal-bar-chart>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HorizontalBarChart from '../charts/HorizontalBarChart'

export default {
  components: {
    HorizontalBarChart
  },
  created () {
    this.$store.dispatch('getAssessmentIndicatorsByPerson', { demographic: this.indicatorsDemographicField })
  },
  data: function () {
    return {
      'assessmentIndicatorFilter': 'All',
      'assessmentIndicatorFilterOptions': {
        'All': 'All',
        'b_confirmed': 'Confirmed',
        'dmst_conclusion': 'Possible Victim'
      },
      'indicatorsDemographicField': 'b_gender',
      'comparisonIndicatorOne': 'i_no_identification',
      'comparisonIndicatorTwo': 'i_runaway'
    }
  },
  computed: {
    ...mapGetters({
      assessmentIndicators: 'getAssessmentIndicators',
      assessmentIndicatorsByPerson: 'getAssessmentIndicatorsByPerson',
      assessmentFields: 'getAssessmentFields',
      biographicOptions: 'getPersonBiographicOptions'
    }),
    sortedAssessmentIndicatorsByPerson: function () {
      if (this.assessmentIndicatorsByPerson.length === 0) {
        return []
      }

      let orderedData = []

      const first = this.assessmentIndicatorsByPerson[0]

      if (first.hasOwnProperty('groupByValue')) {
        orderedData = _.chain(this.assessmentIndicatorsByPerson)
          .groupBy((stat) => stat.groupByValue)
          .value()
      }

      if (!(first.hasOwnProperty('groupByValue'))) {
        orderedData = _.chain(this.assessmentIndicatorsByPerson)
          .orderBy(['value'], ['desc'])
          .value()
      }

      return orderedData
    }
  },
  watch: {
    assessmentIndicatorFilter: function (newValue) {
      this.getAssessmentIndicators()
    },
    indicatorsDemographicField: function (newValue) {
      this.getAssessmentIndicators()
    }
  },
  methods: {
    getAssessmentIndicators () {
      let params = {
        demographic: this.indicatorsDemographicField
      }

      if (this.assessmentIndicatorFilter === 'b_confirmed') {
        params.b_confirmed = 'Yes'
      }

      if (this.assessmentIndicatorFilter === 'dmst_conclusion') {
        params.dmst_conclusion = true
      }

      this.$store.dispatch('getAssessmentIndicatorsByPerson', params)
    },
    getChartNameFromIndicator (indicator) {
      let field = _.find(this.assessmentFields, f => f.name === indicator)

      return field.label
    },
    getSingleIndicator: function (indicator) {
      let single = _.filter(this.assessmentIndicatorsByPerson, (s) => s.field === indicator)
      return single
    },

    getSingleIndicatorLabels: function (indicator) {
      return Object.keys(this.sortedAssessmentIndicatorsByPerson)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/charts/AssessmentIndicatorsComparison.vue